import {
  AuthorizationType,
  Config,
  GuestType,
  IAuthorization,
  ISearchUser,
  UserActionType,
} from "../types/userTypes";
import {UserState} from "../../passapp-sdk/types/userTypes";

export interface IUserAction<T> {
  type: keyof typeof UserActionType;
  payload?: T;
}

export const setUserChange = (field: any, value: any): IUserAction<any> => {
  return {
    type: "USER_CHANGE_NAME",
    payload: {
      field,
      value,
    },
  };
};

export const addAuthorization = (value: IAuthorization): IUserAction<any> => {
  return {
    type: "USER_ADD_AUTHORIZATION",
    payload: value,
  };
};

export const markAuthorization = (
  id: string,
  value: boolean,
  type: AuthorizationType
): IUserAction<any> => {
  return {
    type: "USER_MARK_AUTHORIZATION",
    payload: { id, value, type },
  };
};

export const toggleAuthorization = (
  id: string,
  value: GuestType,
  type: AuthorizationType
): IUserAction<any> => {
  return {
    type: "USER_TOGGLE_AUTHORIZATION",
    payload: { id, value, type },
  };
};

export const hiddenAuthorization = (
  id: string,
  type: AuthorizationType
): IUserAction<any> => {
  return {
    type: "USER_HIDDEN_AUTHORIZATION",
    payload: { id, type },
  };
};

export const setEventId = (id: string): IUserAction<any> => {
  return {
    type: "USER_SET_EVENT_ID",
    payload: id,
  };
};

export const isUserBlackList = (): IUserAction<any> => {
  return {
    type: "USER_IS_BLACK_LIST",
  };
};

export const isUserResident = (): IUserAction<any> => {
  return {
    type: "USER_IS_RESIDENT",
  };
};

export const setSearchCompanion = (options: {
  search: ISearchUser;
  config: Config;
}): IUserAction<any> => {
  return {
    type: "USER_SET_SEARCH_COMPANION",
    payload: options,
  };
};

export const addUserCompanion = (companion: UserState): IUserAction<any> => {
  return {
    type: "USER_ADD_COMPANION",
    payload: companion,
  };
};

export const deleteUserCompanion = (id: string): IUserAction<any> => {
  return {
    type: "USER_DELETE_COMPANION",
    payload: id,
  };
};

export const userSetVehicleType = (vehicleType: string): IUserAction<any> => {
  return {
    type: "USER_SELECT_TYPE_VEHICLE",
    payload: vehicleType,
  };
};

export const userSelectVehicle = (vehicle: any): IUserAction<any> => {
  return {
    type: "USER_SELECT_VEHICLE",
    payload: vehicle,
  };
};

export const userResetSelectVehicle = (): IUserAction<any> => {
  return {
    type: "USER_RESET_SELECT_VEHICLE",
  };
};

export const userShowCompanionSection = (show: boolean): IUserAction<any> => {
  return {
    type: "USER_SHOW_COMPANION_SECTION",
    payload: show,
  };
};

export const setVehicles = (vehicles: any): IUserAction<any> => {
  return {
    type: "USER_SET_VEHICLES",
    payload: vehicles,
  };
};

export const setChangeModify = (): IUserAction<any> => {
  return {
    type: "USER_NOT_NEW_VEHICLE",
  };
};

export const setChangeNew = (): IUserAction<any> => {
  return {
    type: "USER_IS_NEW_VEHICLE",
  };
};

export const userShowDialogCompanion = (show: boolean): IUserAction<any> => {
  return {
    type: "USER_SHOW_DIALOG_COMPANION",
    payload: show,
  };
};

export const setFieldsChangesVehicle = (
  name: any,
  value: any
): IUserAction<any> => {
  return {
    type: "USER_VEHICLE_FIELD_CHANGES",
    payload: {
      name,
      value,
    },
  };
};

export const setVehiclePhoto = (id: string, photo: any): IUserAction<any> => {
  return {
    type: "USER_VEHICLE_NEW_LOCAL_PHOTO",
    payload: {
      id,
      photo,
    },
  };
};

export const setBlackListAuthorization = (
  authorizedBy: string
): IUserAction<any> => {
  return {
    type: "USER_BLACKLIST_AUTHORIZATION",
    payload: authorizedBy,
  };
};

export const setMarkRegisterExit = (id: string): IUserAction<any> => {
  return {
    type: "USER_MARK_EXIT",
    payload: id,
  };
};

export const setEditUser = (user: UserState): IUserAction<any> => {
  return {
    type: "USER_EDIT_EXIT",
    payload: user,
  };
};

export const setAceptUnknown = (): IUserAction<any> => {
  return {
    type: "USER_ACEPT_UNKNOWN",
  };
};

export type UserActions = IUserAction<any>;
